import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Card } from '@material-ui/core';
import { BASE_URL, IMAGE_PATHS } from '../../../constants/paths.constants';
import { transparentWhite, poslumaDarkBlue } from '../../../app/theme';
import IndicationContent from './PoslumaIndicationContent';

const useStyles = makeStyles(() => ({
  container: {
    paddingTop: 30,
    height: 212,
    position: 'relative',
  },
  card: {
    padding: '15px 30px',
    paddingRight: 100,
    margin: '0 30px',
    borderRadius: '18px 18px 0 0',
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
  minimized: {
    boxShadow: 'none',
  },
  maximized: {
    boxShadow: `-1px 0px 2px ${transparentWhite}, 3px 0px 3px ${transparentWhite}`,
  },
  list: {
    marginTop: 0,
    marginBottom: 0,
  },
  toggleButton: {
    position: 'absolute',
    top: 24,
    right: 24,
  },
  link: {
    color: poslumaDarkBlue,
    textTransform: 'none',
    textDecoration: 'underline',
    padding: 0,
    fontSize: 'inherit',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
  bold: {
    fontWeight: 600,
    fontSize: 20,
  },
  text: {
    fontSize: 20,
    lineHeight: 1.3,
  },
  icon: {
    width: 24,
  },
}));

const Indication = (): JSX.Element => {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(false);
  const [toggleImagePath, setToggleImagePath] = useState(
    `${BASE_URL}${IMAGE_PATHS.TRAINING_PAGES[2].EXPAND_ICON.path}`,
  );

  const togglePanel = (expand: boolean) => {
    setExpanded(expand);
    setToggleImagePath(
      expand
        ? `${BASE_URL}${IMAGE_PATHS.TRAINING_PAGES[2].CONTRACT_ICON.path}`
        : `${BASE_URL}${IMAGE_PATHS.TRAINING_PAGES[2].EXPAND_ICON.path}`,
    );
  };

  return (
    <div className={classes.container}>
      <Card className={`${classes.card} ${expanded ? classes.maximized : classes.minimized}`}>
        <Button className={classes.toggleButton} onClick={() => togglePanel(!expanded)}>
          <img
            className={classes.icon}
            src={toggleImagePath}
            alt={`${IMAGE_PATHS.TRAINING_PAGES[2].EXPAND_ICON.alt}`}
          />
        </Button>
        <IndicationContent isOpen={expanded} />
      </Card>
    </div>
  );
};

export default Indication;
